
import TabPanel, { Item } from "devextreme-react/tab-panel";
import DashBoard from './dashboard/dashboard';
import SalesPerformanceGridReportReportOne from './grids/sales-performance-grid-report-one';
import SalesPerformanceGridReportReportTwo from './grids/sales-performance-grid-report-two';
import SalesPerformanceGridReportReportThree from './grids/sales-performance-grid-report-three';
import SalesPerformanceGridReportReportFour from './grids/sales-performance-grid-report-four';
import { useTranslation } from 'react-i18next';
import { t } from "i18next";


export default function SalesPerformanceReport() {
    return (
        <>


            <TabPanel>
                <Item title={t("dashboard")}>
                    <DashBoard></DashBoard>
                </Item >
                <Item title={t("grid_report_one")}>
                    <SalesPerformanceGridReportReportOne></SalesPerformanceGridReportReportOne>
                </Item >
                <Item title={t("grid_report_two")}>
                    <SalesPerformanceGridReportReportTwo></SalesPerformanceGridReportReportTwo>
                </Item >
                <Item title={t("grid_report_three")}>
                    <SalesPerformanceGridReportReportThree></SalesPerformanceGridReportReportThree>
                </Item >
                <Item title={t('grid_report_four')}>
                    <SalesPerformanceGridReportReportFour></SalesPerformanceGridReportReportFour>
                </Item >
            </TabPanel>

        </>
    );
}
